import Head from 'next/head';

interface JsonLdProps {
  readonly id: string;
  readonly data: Record<string, unknown> | readonly Record<string, unknown>[];
}

const JsonLd: React.FC<JsonLdProps> = ({ id, data }) => {
  return (
    <Head>
      <script
        key={id}
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
      />
    </Head>
  );
};

export default JsonLd;
